module.exports = __webpack_public_path__ + "static/img/icon.c2065dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/bba/icon.png
// module id = 2yJu
// module chunks = 0